(function () {
    'use strict';

angular.module('app.controllers.controlLogicSettings', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('controllogicsettings', {
            abstract: true,
            parent: 'site',
            template: '<ui-view/>',
            url: '/ControlLogicSettings'
        });
    }])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('controllogicsettings.default', {
            parent: 'controllogicsettings',
            url: '/',
            templateUrl: 'views/CustomActions/controllogicsettings.html',
            //defaultParams: { heatingCurve: '1' },
            controller: 'ControlLogicSettingsCtrl',
            breadcrumb: {
                name: function () {
                    return 'NAV_ControlLogicSettings';
                }
            }
        });
    }])
    .controller("ControlLogicSettingsCtrl",
    [
    '$rootScope', '$scope',
              'f_Info', 'f_Interval',
             'f_controllogicService', 'viewMenuBarService', '__MenuEntry',
             '$translate', 'API',
    function ($rootScope, $scope,
              f_Info, f_Interval,
              f_controllogicService, viewMenuBarService, __MenuEntry,
              $translate, API) {

              var favoriteObject = {
                  favoriteType: 'MenuEntry',
                  favoriteObject: __MenuEntry.$buildRaw({
                      "MenuEntryId": '6bbbcb7a-b7bc-401b-b977-95fa096035b7',
                      "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                      "DeviceId": '00000000-0000-0000-0000-000000000000',
                      'CustomActionName': "ControlLogicSettings",
                      'DisplayName': $translate.instant('NAV_ControlLogicSettings'),
                      'ImageName': 'anlagen-konfiguration',
                      'UserLevelRead': 40,
                      'UserLevelWrite': 40,
                      'CustomActionDatas': {},
                      $UI: {}
                  })
              };
              viewMenuBarService.setFavorite(favoriteObject);
              viewMenuBarService.setButtons({});

            /**
             * Overwrites obj1's values with obj2's and adds obj2's if non existent in obj1
             * @param obj1
             * @param obj2
             * @returns obj3 a new object based on obj1 and obj2
             */
            function merge_options(obj1, obj2) {
                var obj3 = {};
                for (var attrname1 in obj1) {
                    if (obj1.hasOwnProperty(attrname1)) {
                        obj3[attrname1] = obj1[attrname1];
                    }
                }
                for (var attrname2 in obj2) {
                    if (obj2.hasOwnProperty(attrname2)) {
                        obj3[attrname2] = obj2[attrname2];
                    }
                }
                return obj3;
            }

            function updateBoundDevice(boundDevice, updatedDeviceData) {
                if (boundDevice.Name !== updatedDeviceData.Name) {
                    boundDevice.Name = updatedDeviceData.Name;
                }
                if (boundDevice.Failed !== updatedDeviceData.Failed) {
                    boundDevice.Failed = updatedDeviceData.Failed;
                    boundDevice.BackgroundGradient = checkForFailure(boundDevice.Failed);
                }
                if (boundDevice.Enabled !== updatedDeviceData.Enabled) {
                    boundDevice.Enabled = updatedDeviceData.Enabled;
                }
                if (boundDevice.Frequency !== updatedDeviceData.Frequency) {
                    boundDevice.Frequency = updatedDeviceData.Frequency;
                }
                if (boundDevice.IsRunning !== updatedDeviceData.IsRunning) {
                    boundDevice.IsRunning = updatedDeviceData.IsRunning;
                }
                if (boundDevice.LastExecutionTimeUtc !== updatedDeviceData.LastExecutionTimeUtc) {
                    boundDevice.LastExecutionTimeUtc = updatedDeviceData.LastExecutionTimeUtc;
                }
                if (boundDevice.LastExecutionDurationMs !== updatedDeviceData.LastExecutionDurationMs) {
                    boundDevice.LastExecutionDurationMs = updatedDeviceData.LastExecutionDurationMs;
                }
            }

            function getNewData() {
                f_controllogicService
                    .get()
                    .then(function (responses) {
                        loadNewData(responses);
                    });
            }

            function loadNewData(responses) {
                var controlLogicSettingsList = [];

                if (responses[0].length !== responses[1].length) {
                    var info = {
                        "TitleTranslated": 'ERROR_SettingsStatesNotMatching'
                    };
                    f_Info.addInfo(info);
                    return false;
                }

                for (var i = 0; i < responses[0].length; i++) {
                    controlLogicSettingsList.push(merge_options(responses[0][i], responses[1][i]));
                    controlLogicSettingsList[i].Id = i;
                    controlLogicSettingsList[i].BackgroundGradient = checkForFailure(controlLogicSettingsList[i].Failed);
                }

                // First loading, just assign the data
                if (angular.equals({}, $scope.controlLogicSettingsList)) {
                    $scope.controlLogicSettingsList = controlLogicSettingsList;
                }
                // reset devices, if the number of old and new devices change
                else if ($scope.controlLogicSettingsList.length !== controlLogicSettingsList.length) {
                    $scope.controlLogicSettingsList = controlLogicSettingsList;
                }
                else {
                    // update all relevant changes for all devices
                    for (var j = 0; j < $scope.controlLogicSettingsList.length; j++) {
                        updateBoundDevice($scope.controlLogicSettingsList[j], controlLogicSettingsList[j]);
                    }
                }

                // console.log($scope.controlLogicSettingsList[0]);
            }

            function checkForFailure(failed) {
                if (failed) {
                    return "red-gradient";
                }
                else {
                    return "gradient";
                }
            }

            $scope.pageClass = 'LogicControl';
            $scope.$on('InitActualView', function () {
                $scope.init();
            });

            $scope.saveFrequency = function(cb) {
                if (!cb.value || cb.value === 0) {
                    return;
                }

                var jObj = {
                    'Name': $scope.controlLogicSettingsList[cb.params.index].Name,
                    'Frequency': cb.value,
                    'Enabled': $scope.controlLogicSettingsList[cb.params.index].Enabled
                };

                $rootScope.loading = true;

                var api = new API();
                api.System.UpdateControlLogicSettings({ Settings: [jObj] }).$promise.then(function(){
                    //$scope.forceLoadNewData();
                })
                .finally(function() {
                    $rootScope.loading = false;
                });
            };

            $scope.saveEnabledState = function(cb) {
                var jObj = {
                    'Name': $scope.controlLogicSettingsList[cb.params.index].Name,
                    'Frequency': $scope.controlLogicSettingsList[cb.params.index].Frequency,
                    'Enabled': cb.value
                };

                $rootScope.loading = true;

                var api = new API();
                api.System.UpdateControlLogicSettings({ Settings: [jObj] }).$promise.then(function(){
                    //$scope.forceLoadNewData();
                })
                .finally(function() {
                    $rootScope.loading = false;
                });

            };

            $scope.init = function () {
                $rootScope.loading = true;
                $scope.controlLogicSettingsList = {};
                $scope.inputType = 'number';

                $scope.intervalId = f_Interval.registerInterval({
                    'AppId': 'LogicUpdate',
                    delay: conf_intervall_valuerefresh,
                    fn: function () {
                        getNewData();
                    }
                }, true);

                $scope.forceLoadNewData = function () {
                    // console.log('force load');
                    getNewData();
                };

                $scope.$on('$destroy', function () {
                    f_Interval.unregisterIntervalByAppId($scope.intervalId);
                });

                // Set Buttons and Functions
                $rootScope.editbutton = false;
                $rootScope.backbutton = true;
                $rootScope.sortbutton = false;
                $scope.editmode = false;

                $rootScope.favoriteObject = $scope.favoriteObject;
                $rootScope.favoritebutton = true;
                $rootScope.favoriteFunction = function (ob) {
                   // MasterService.toggleFavorite(ob);
                };
                $rootScope.$broadcast('FavoriteHeadChange', {object: $scope.favoriteObject});
            };

            // User Level Changed
            $scope.$on('UserlevelChange', function () {
                $scope.init();
                $rootScope.loading = false;
            });

            $scope.init();
        }]
).filter('parseNameFromFullname', function () {
    return function (fullname) {
        if (fullname === undefined || fullname === null) {
            return '';
        }

        if (fullname[fullname.length] === '.') {
            fullname = fullname.substring(0, fullname.length);
        }

        var lastDotIndex = fullname.lastIndexOf('.') + 1;
        if (lastDotIndex === 0) {
            return fullname;
        }

        return fullname.substring(lastDotIndex);
    };
}).filter('utcToLocal', ['$filter', function ($filter) {
    /* http://jasonwatmore.com/post/2016/03/31/AngularJS-UTC-to-Local-Date-Time-Filter.aspx */
    return function (utcDateString, format) {
        // return if input date is null or undefined
        if (!utcDateString) {
            return;
        }

        // append 'Z' to the date string to indicate UTC time if the timezone isn't already specified
        if (utcDateString.indexOf('Z') === -1 && utcDateString.indexOf('+') === -1) {
            utcDateString += 'Z';
        }

        // convert and format date using the built in angularjs date filter
        return $filter('date')(utcDateString, format);
    };
}]);


})();
